import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Autocomplete from "@mui/material/Autocomplete";
import { AlertContext } from "../../../context/AlertContext";
import { ServiciosContext } from "../../../context/ServiciosContext";
import { ConfiguracionContext } from "../../../context/ConfiguracionContext";
import { ThemeProvider, createMuiTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/material/styles";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import Spinner from ".././Spinner";
import { AuthContext } from "../../../context/AuthContext";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Tag } from "primereact/tag";
import { InputText } from "primereact/inputtext";
import ButtonMui from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Navigate, useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import Menu from ".././Menu";
import { MultiSelect } from "primereact/multiselect";
import { InputMask } from "primereact/inputmask";
import { SelectButton } from "primereact/selectbutton";

const exportColumnsListado = [
  { title: "Titular", dataKey: "titularId" },
  { title: "Nombre", dataKey: "nombreTitular" },
  { title: "Color", dataKey: "color" },
  { title: "Cantidad", dataKey: "cantidad" },
  { title: "Tope", dataKey: "tope" },
];

const exportColumnsListadoCardio = [
  { title: "Titular", dataKey: "titularId" },
  { title: "Nombre", dataKey: "nombre" },
  { title: "Cantidad", dataKey: "cantidad" },
  { title: "Tipo", dataKey: "tipo" },
  { title: "Importe", dataKey: "importe" },
];

export default function ListadosTopesServicios(props) {
  const [globalFilter, setGlobalFilter] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const options = ["Mensual", "Anual"];
  const [value, setValue] = useState(options[0]);
  const [selectedCities, setSelectedCities] = useState([]);

  const [visibleFechas, setVisibleFechas] = useState(true);
  const [fechaDesde, guardarFechaDesde] = useState(null);
  const [fechaHasta, guardarFechaHasta] = useState(null);
  const [periodo, setPeriodo] = useState(false);
  const [anio, setAnio] = useState(false);

  const toast = useRef(null);

  let navigate = useNavigate();

  //Context

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state, usuarioAutenticado } = authContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const {
    statusAcceso,
    empresaElegida,
    empresas,
    configuracion,
    colores,
    topes,
    listadoExcel,
    obtenerAcceso,
    obtenerBajas,
    obtenerEmpresas,
    obtenerTopesServicios,
    obtenerColores,
  } = configuracionContext;

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({
        usuarioId: state.usuario.id,
        layout: "ListadosTopesServicios",
      });
    }
  }, [state.id]);

  useEffect(() => {
    obtenerColores();
  }, []);

  function formatDate(input) {
    var datePart = input.match(/\d+/g),
      year = datePart[0],
      month = datePart[1],
      day = datePart[2];
    return day + "/" + month + "/" + year;
  }

  const exitClick = (e) => {
    navigate("/");
  };

  const onHideFechas = (e) => {
    setVisibleFechas(false);
    exitClick();
  };

  const aceptarFechas = async (exportType) => {
    //e.preventDefault();
    //Validar

    if (configuracion && configuracion === 1) {
      if (value === "Mensual") {
        if (
          !periodo ||
          periodo === undefined ||
          periodo === null ||
          periodo === "" ||
          periodo === 0
        ) {
          mensajeAlerta("Topes", "El período es necesario !.", "error");
          return;
        }
      }

      if (value === "Anual") {
        if (
          !anio ||
          anio === undefined ||
          anio === null ||
          anio === "" ||
          anio === 0
        ) {
          mensajeAlerta("Topes", "El año es necesario !.", "error");
          return;
        }
      }

      if (!selectedCities || selectedCities.length === 0) {
        mensajeAlerta("Topes", "Debe seleccionar algún color !.", "error");
        return;
      }
    }

    var elem;

    toast.current.show({
      severity: "info",
      summary: "Mensajes",
      detail: "Obteniendo información... !",
      life: 3000,
    });

    await obtenerTopesServicios({
      tipo: value,
      periodo: periodo,
      anio: anio,
      selectedCities,
      exportType,
      destinatario:
        configuracion && configuracion.destinatario
          ? configuracion && configuracion.destinatario
          : 0,
    }).then((data) => {
      if (exportType === "excel") {
        elem = document.getElementById("expButtonExcel");
        elem.click();
      }
      if (exportType === "pdf") {
        elem = document.getElementById("expButtonPdf");
        elem.click();
      }
    });
    /*
    onHideFechas();
    setGrupo(null);
    guardarVigencia({
      desde: null,
      hasta: null,
    });
    setIncluyeIntegrantes(false);
    setTodasLasEmpresas(false);
    */
  };

  const accesoDenegado = () => {
    mensajeAlerta(
      "Listado de Topes de Servicios",
      "No tiene permiso para acceder a esta pantalla !.",
      "error",
    );
    exitClick();
    return;
  };

  const renderHeaderFechas = () => {
    return (
      <div>
        <Tag value="Topes de Servicios"></Tag>
      </div>
    );
  };

  const renderFooterFechas = () => {
    return (
      <div>
        <button
          id="expButtonExcel"
          type="button"
          onClick={(e) => {
            exportExcel();
          }}
          style={{ visibility: "hidden" }}
        >
          Export Excel
        </button>
        <button
          id="expButtonPdf"
          type="button"
          onClick={(e) => {
            exportPdf();
          }}
          style={{ visibility: "hidden" }}
        >
          Export Pdf
        </button>

        <Button
          icon="pi pi-file-excel"
          onClick={(e) => {
            aceptarFechas("excel");
          }}
          className="p-button-raised p-button-success"
          data-pr-tooltip="XLS"
          label="Excel"
        />
        <Button
          icon="pi pi-file-pdf"
          onClick={(e) => {
            aceptarFechas("pdf");
            //exportPdf();
          }}
          className="p-button-raised p-button-warning"
          data-pr-tooltip="PDF"
          style={{ marginRight: "1em" }}
          label="PDF"
        />
        <ButtonMui
          onClick={onHideFechas}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
      </div>
    );
  };

  const fechaTemplate = (rowData) => {
    return <Fragment>{formatDate(rowData.fecha)}</Fragment>;
  };

  const anuladoTemplate = (rowData) => {
    return (
      <Fragment>
        <Checkbox checked={rowData.anulado}></Checkbox>
      </Fragment>
    );
  };

  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(topes);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      saveAsExcelFile(excelBuffer, "topesdeServicios");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      return new Promise((resolve) => {
        saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION,
        );
        resolve(true);
      });
    });
  };

  const exportPdf = () => {
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const doc = new jsPDF.default();
        doc.setFontSize(10);

        if (configuracion && configuracion.destinatario === 1) {
          if (value === "Mensual") {
            doc.text(`Listado de topes de servicios período ${periodo}`, 60, 8);
          } else {
            doc.text(`Listado de topes de servicios año ${anio}`, 60, 8);
          }

          doc.autoTable(exportColumnsListado, topes, {
            styles: {
              fontSize: 6,
            },
          });
        } else {
          doc.text(`Listado de topes de servicios`, 60, 8);
          doc.autoTable(exportColumnsListadoCardio, topes, {
            styles: {
              fontSize: 6,
            },
            columnStyles: {
              4: { halign: "right" },
            },
            didParseCell: (data) => {
              if (data.cell.section === "body" && data.column.index === 5) {
                data.cell.text = [data.cell.raw ? "Sí" : "No"];
              }
            },
          });
        }
        //doc.save("modulosAfiliados.pdf");
        window.open(doc.output("bloburl"));
      });
    });
  };

  function formatDate(input) {
    var datePart = input.match(/\d+/g),
      year = datePart[0],
      month = datePart[1],
      day = datePart[2];
    return day + "/" + month + "/" + year;
  }

  function formatDateTime(dateString) {
    var allDate = dateString.replace("T", " ");
    allDate = allDate.replace(".", " ");
    allDate = allDate.split(" ");
    var thisDate = allDate[0].split("-");
    var thisTime = allDate[1].split(":");
    var newDate = [thisDate[2], thisDate[1], thisDate[0]].join("/");
    var newTime = [thisTime[0], thisTime[1]].join(":");
    return newDate + " " + newTime;
  }

  //console.log(topes);
  //console.log(configuracion);

  return (
    <Fragment>
      <Menu />
      <Toast ref={toast} />
      {statusAcceso === 0 ? <Spinner /> : null}
      {statusAcceso === 400 ? accesoDenegado() : null}
      {statusAcceso === 200 ? (
        <Fragment>
          <Dialog
            header={renderHeaderFechas()}
            visible={visibleFechas}
            closable={false}
            footer={renderFooterFechas()}
            breakpoints={{ "960px": "75vw" }}
            style={{ width: "75vw", paddingBottom: "0" }}
            position="top"
          >
            {configuracion && configuracion.destinatario === 1 ? (
              <Grid container spacing={3} style={{ marginTop: "1vw" }}>
                <Grid item xs={12} md={3}>
                  <SelectButton
                    value={value}
                    onChange={(e) => setValue(e.value)}
                    options={options}
                  />
                </Grid>

                {value === "Mensual" ? (
                  <Grid item xs={12} md={3}>
                    <label htmlFor="id">Período</label>
                    <InputMask
                      id="periodo"
                      mask="99/99"
                      value={periodo ? periodo : null}
                      placeholder="99/99"
                      size={4}
                      onChange={(e) => setPeriodo(e.value)}
                      style={{ marginLeft: "0.7vw", marginTop: "0.2vw" }}
                    ></InputMask>
                  </Grid>
                ) : (
                  <Grid item xs={12} md={3}>
                    <label htmlFor="id">Año</label>
                    <InputMask
                      id="anio"
                      mask="9999"
                      value={anio ? anio : null}
                      placeholder="9999"
                      size={4}
                      onChange={(e) => setAnio(e.value)}
                      style={{ marginLeft: "0.7vw", marginTop: "0.2vw" }}
                    ></InputMask>
                  </Grid>
                )}

                <Grid
                  item
                  xs={12}
                  md={12}
                  style={{ paddingLeft: "1vw", marginTop: "1vw" }}
                >
                  <label htmlFor="id">Colores</label>

                  <MultiSelect
                    value={selectedCities}
                    onChange={(e) => setSelectedCities(e.value)}
                    options={colores ? colores : null}
                    optionLabel="nombre"
                    placeholder="Seleccione los colores"
                    maxSelectedLabels={10}
                    display="chip"
                    style={{ marginLeft: "1vw" }}
                    //className="w-full md:w-40rem"
                  />
                </Grid>
              </Grid>
            ) : null}
          </Dialog>
        </Fragment>
      ) : null}
      <Grid item xs={12} sm={12}></Grid>
    </Fragment>
  );
}

/* class="MuiDataGrid-cell MuiDataGrid-cellLeft" */
